// extracted by mini-css-extract-plugin
export default {"wrapper":"FindHotelByInvoiceIdDialog_wrapper__5pGtu"};